import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { COLORS, FONT } from '../theme';
import { PageTitleProvider } from '../context/PageTitleContext';

function tituloDaPagina(itens, paginaAtiva) {
  for (const item of itens) {
    if (item.chave === paginaAtiva) return item.titulo;
    if (item.grupo) {
      const sub = item.grupo.find(s => s.chave === paginaAtiva);
      if (sub) return sub.titulo;
    }
  }
  return '';
}

export default function AppLayout({ paginaAtiva, onNavegar, itens, children }) {
  return (
    <PageTitleProvider>
      <div style={{ display: 'flex', minHeight: '100vh', background: COLORS.bg, fontFamily: FONT }}>
        <Sidebar paginaAtiva={paginaAtiva} onNavegar={onNavegar} itens={itens} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <TopBar tituloPadrao={tituloDaPagina(itens, paginaAtiva)} onNavegar={onNavegar} />
          <main style={{ flex: 1, padding: 28, overflowX: 'auto' }}>
            {children}
          </main>
        </div>
      </div>
    </PageTitleProvider>
  );
}
